import { render, staticRenderFns } from "./FormularioPCCHistorial.vue?vue&type=template&id=4418ef2c&scoped=true&"
import script from "./FormularioPCCHistorial.vue?vue&type=script&lang=js&"
export * from "./FormularioPCCHistorial.vue?vue&type=script&lang=js&"
import style0 from "./FormularioPCCHistorial.vue?vue&type=style&index=0&id=4418ef2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4418ef2c",
  null
  
)

export default component.exports